module.exports = __webpack_public_path__ + "static/media/emma-watson-win.bb1367aa.jpg";